/**
 * Created by mariushirjanu on 10/06/2020.
 */
import * as _ from 'underscore';
import { trackByFunction } from '../../../../shared/formly/ga-formly.util';
import { Component, Input, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { CatalogStateService } from '../catalog-state.service';
import { CatalogOverviewService } from './catalog-overview.service';
import { OrderCatalogService } from '../order-catalog.service';
import { ICatalogProduct } from '../order-catalog-data.service';

@Component({
  selector: 'catalog-overview-layout-tabularbasic',
  template: `
    <table class="catalog-layout catalog-layout-tabular-basic table table-striped">
      <thead *ngIf="!hideHeader">
        <tr>
          <th class="warning-field"></th>
          <th></th>
          <th class="part" translate="CATALOG.HEADERS.PARTNR"></th>
          <th class="category" translate="CATALOG.HEADERS.CATEGORY"></th>
          <th class="d-sm-none d-md-table-cell"></th>
          <th class="description" translate="CATALOG.HEADERS.DESCRIPTION"></th>
          <th class="d-sm-none d-md-table-cell"></th>
          <th class="price" translate="CATALOG.HEADERS.PRICE" *ngIf="!hidePrices"></th>
          <th class="stock" *ngIf="showStock" translate="CATALOG.HEADERS.STOCK_COUNT"></th>
          <th class="eol d-sm-none d-md-table-cell" translate="CATALOG.HEADERS.EOL"></th>
          <th class="lead-time" *ngIf="showLeadTime">Lead Time</th>
          <th class="vendor d-sm-none d-md-table-cell" translate="CATALOG.HEADERS.VENDOR"></th>
          <th class="global-part" translate="CATALOG.HEADERS.GLOBAL_PARTNR"></th>
          <th class="lease-price" translate *ngIf="showLease">CATALOG.HEADERS.LEASING_PRICE</th>
          <th class="lease-period" translate *ngIf="showLease">CATALOG.HEADERS.LEASING_PERIOD</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; trackBy: trackByFunction" [scrollTarget]="getScrollTarget(product.id)" scrollPaddingTop="55">
          <td class="warning-field">
            <div *ngIf="product.EOL && (product.EOL.warning || product.warning)">
              <i *ngIf="product.EOL.warning" class="fa fa-warning" title="{{'CATALOG.DETAIL.EOL_WARNING' | translate: {date: product.EOL.date} }}"></i>
              <i *ngIf="product.warning" title="{{product.warning}}" class="fa fa-warning"></i>
            </div>
          </td>
          <td class="add-to-cart-wrap">
            <add-to-cart *ngIf="!hasCartAction" [product]="product" [catalogView]="true" [mini]="true"></add-to-cart>
            <add-to-cart *ngIf="hasCartAction" [product]="product" [catalogView]="true" [mini]="true" [noStatus]="noStatus"></add-to-cart>
          </td>
          <td class="part">
            <a uiSref="{{ orderDetailsSref }}" [uiParams]="getOrderDetailsSrefParams(product.id)" class="badge partnumber">{{product.part}}</a>
          </td>
          <td class="category">{{product.category}}</td>
          <td class="favourite">
            <favourite-toggle [productId]="product.id" [isFavourite]="product.favourite"></favourite-toggle>
          </td>
          <td class="description">
            <div class="d-md-none d-lg-block">{{product.shortDescription}}</div>
            <div class="d-sm-none d-md-none d-lg-none">
              <a uiSref="{{ orderDetailsSref }}" [uiParams]="getOrderDetailsSrefParams(product.id)">{{product.shortDescription}}</a>
            </div>
          </td>
          <td class="description-link d-sm-none d-md-table-cell">
            <a uiSref="{{ orderDetailsSref }}" [uiParams]="getOrderDetailsSrefParams(product.id)" class="detail-link">
              <span translate="CATALOG.DETAIL.DETAIL_LINK"></span>
              <i class="fa fa-angle-right"></i>
            </a>
          </td>
          <td class="price" *ngIf="!hidePrices">{{formatAmount(product.price.amount)}}</td>
          <td *ngIf="showStock" class="stock">{{product.stock}}</td>
          <td class="eol d-sm-none d-md-table-cell" [ngClass]="{'warn': product.EOL?.warning}">{{product.EOL?.date}}</td>
          <td class="lead-time" *ngIf="showLeadTime" [ngClass]="{'warn': product.leadTime?.warning}">
            <span *ngIf="product.leadTime?.warning">
              <i class="fa fa-warning"></i>
            </span>
            <span *ngIf="!product.leadTime?.warning"> <!-- this acts as a spacer -->
              <i class="fa fa-warning" style="color:transparent"></i>
            </span>
            <span>{{product.leadTime?.text}}</span>
          </td>
          <td class="vendor d-sm-none d-md-table-cell">{{product.vendor}}</td>
          <td class="global-part">
            <a *ngIf="product.globalPart" uiSref="{{ orderDetailsSref }}" [uiParams]="getOrderDetailsSrefParams(product.id)" class="badge partnumber">{{product.globalPart}}</a>
          </td>
          <td class="lease-price" *ngIf="showLease">
            <span *ngIf="product.unitLeasePrice?.amount">{{formatAmount(product.unitLeasePrice?.amount)}}</span>
          </td>
          <td class="lease-period text-center" *ngIf="showLease">{{product.leasePeriod}}</td>
        </tr>
      </tbody>
    </table>
  `
})
export class CatalogOverviewLayoutTabularbasicComponent implements OnInit, OnChanges {
  // bindings
  @Input() public products:ICatalogProduct[];
  @Input() public hideHeader:boolean;
  @Input() public noStatus:boolean;
  @Input() public showStock:boolean;
  @Input() public compatibleProductId:number;
  @Input() public hasCartAction:boolean;
  @Input() public hidePrices:boolean;
  @Input() public showLease:boolean;

  public orderDetailsSref:string;
  public formatAmount:Function = this.orderCatalogService.formatAmount;
  public getOrderDetailsSrefParams:Function = (productId:number) => this.catalogOverviewService.getOrderDetailsSrefParams(productId, this.compatibleProductId);
  public showLeadTime:boolean;
  public trackByFunction:Function = trackByFunction;

  constructor(
    private catalogStateService:CatalogStateService,
    private catalogOverviewService:CatalogOverviewService,
    private orderCatalogService:OrderCatalogService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.activate();
  }

  private activate():void {
    this.orderDetailsSref = this.catalogStateService.detailState;
  }

  public getScrollTarget(productId:number):string {
    return `product-${productId}`;
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.products?.currentValue) {
      this.products = changes.products.currentValue;
      this.showLeadTime = !!_.find(this.products, (product:any) => !!product.leadTime?.days);
    }
  }
}